var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEoltReportSvgrepocom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.3335L18.3333 6.66683V16.6668H1.66666V3.3335H15ZM14.5833 5.00016H3.33333V15.0002H16.6667V7.0835L14.5833 5.00016ZM7.5 12.5002V13.7502H5V12.5002H7.5ZM15 12.5002V13.7502H9.16666V12.5002H15ZM7.5 10.0002V11.2502H5V10.0002H7.5ZM15 10.0002V11.2502H9.16666V10.0002H15ZM7.5 7.50016V8.75016H5V7.50016H7.5ZM15 7.50016V8.75016H9.16666V7.50016H15Z",
    fill: "#1C1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEoltReportSvgrepocom);
export default __webpack_public_path__ + "static/media/eolt_report_svgrepo.com.1da9f87bd20738db8aed9891f727e2f4.svg";
export { ForwardRef as ReactComponent };